import React, { ReactElement } from "react";
import classes from "./style.module.scss";
import cn from "classnames";

export type ButtonVariant = "primary" | "secondary" | "danger" | "remove";

export type ButtonProps = {
  sx?: React.CSSProperties;
  onClick?: (...args: unknown[]) => unknown;
  title?: string;
  type?: "button" | "submit" | "reset";
  inputAdornment?: null | string;
  disabled?: boolean;
  cls?: string;
  variant?: ButtonVariant;
  icon?: string;
  isActive?: boolean;
  iconPosition?: "left" | "right";
  children?: Element | ReactElement;
  className?: string;
};

const BasicButton = ({
  sx,
  onClick,
  title,
  type = "button",
  inputAdornment = null,
  disabled = false,
  cls,
  variant = "primary",
  icon,
  isActive = true,
  iconPosition = "left",
}: ButtonProps) => {
  return (
    <button
      disabled={disabled}
      type={type}
      className={cn(classes.basicButtonStyles, {
        [classes.primary]: variant === "primary",
        [classes.secondary]: variant === "secondary",
        [classes.danger]: variant === "danger",
        [classes.remove]: variant === "remove",
        [classes.disabled]: disabled,
        [classes.noTitle]: !title,
        ...(cls ? { [cls]: true } : {}),
      })}
      style={{ ...sx }}
      onClick={onClick && onClick}
    >
      {iconPosition === "left" && icon && (
        <img
          src={icon}
          alt="Remove"
          className={!isActive ? classes.disabledIcon : ""}
        />
      )}
      {inputAdornment && (
        <img
          style={{ marginRight: title ? "8px" : "0" }}
          src={inputAdornment}
          alt="button input"
        />
      )}
      {title && <span>{title}</span>}
      {iconPosition === "right" && icon && (
        <img
          src={icon}
          alt="Remove"
          className={!isActive ? classes.disabledIcon : ""}
        />
      )}
    </button>
  );
};

export default BasicButton;
